import { render, staticRenderFns } from "./Form4.vue?vue&type=template&id=44fbb875&scoped=true&"
import script from "./Form4.vue?vue&type=script&lang=js&"
export * from "./Form4.vue?vue&type=script&lang=js&"
import style0 from "./Form4.vue?vue&type=style&index=0&id=44fbb875&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fbb875",
  null
  
)

export default component.exports